export default __webpack_public_path__ + "static/media/logo_Agric_Ministry_Mali-removebg-preview.2a4b589a.png";